import { ProductsControllerFindAll$Params } from '@klubovna/api-client';
import { Product } from '@klubovna/api-client';

export interface ProductsState {
  products: Product[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  params: ProductsControllerFindAll$Params;
  loading: boolean;
  error: string | null;
}

export const initialProductsState: ProductsState = {
  products: [],
  total: 0,
  page: 1,
  limit: 20,
  totalPages: 0,
  params: {
    page: 1,
    limit: 20,
    sortBy: 'sortOrder',
    sortOrder: 'ASC',
  },
  loading: false,
  error: null,
};
